import React from 'react';
import { Card } from 'react-bootstrap';
import projectimage6 from "../../assets/img/np6.png";
import projImg6 from "../../assets/img/n6.png";
import ShowMoreText from "react-show-more-text";

const Card6 = () => {
    // Your component logic goes here

    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>The fractal structure of treelines in high mountains</h2></Card.Title> */}

        <Card.Img variant="top" src={projectimage6} />

        <Card.Body>
          <Card.Text>
            {" "}
            <img className="img2" src={projImg6} />{" "}
            <p className="text7">András Póra</p>
            <br />
            <p className="text8">
              Assistant Lecturer <br /> Department of Finance, BME
            </p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
              Comparative analysis of the V4 (Visegrad Group) public debt
              from 1990 to the present: volumes, yields, and interest
              expenses. Description and explanation of public debt
              management strategies (if any can be observed). Capturing
              possible best practices and policy consequences. Main
              research questions:
              <br />
              <ul>
                <li>
                  {" "}
                  How and to what extent did the public debt of the V4
                  countries develop differently after the system change?
                  What were the main trends?{" "}
                </li>
                <br />
                <li>
                  What was the strategy of each country in the short and
                  long term?
                </li>{" "}
                <br />
                <li>
                  How can the differences be explained (stock, currency,
                  economic policy, etc.)?{" "}
                </li>{" "}
                <br />
                <li>
                  Were there any countries that performed significantly
                  better or worse? If so, why?{" "}
                </li>{" "}
                <br />
                <li>
                  Is it possible to draw any future policy consequences
                  from this? Is there a "best practice" in the area?
                </li>
              </ul>
              <br />
              <br />
              Related literature: <br />
              <ul>
                <li>
                  Ali Abbas, S., Belhocine, N., El-Ganainy, A. et al.
                  (2011). Historical Patterns and Dynamics of Public Debt
                  <span className="text9">
                    {" "}
                    Evidence From a New Database. IMF Econ Rev 59{" "}
                  </span>
                  717{"-"}742.{" "}
                </li>
                <br />{" "}
                <li>
                  Semik, S., Zimmermann, L. (2022). Determinants of
                  substantial public debt reductions in Central and
                  Eastern European Countries.{" "}
                  <span className="text9"> Empirica 49 </span>
                  53–70.
                </li>{" "}
                <br />
                <li>
                  Siwinska-Gorzelak, J. (1999). Public Debt Structure and
                  Dynamics in the Czech Republic, Hungary, Poland and
                  Romania.{" "}
                  <span className="text9">
                    {" "}
                    CASE Network Studies and Analyses{" "}
                  </span>
                  No. 162.
                </li>{" "}
                <br />
                <li>
                  Stoian, A., Iorgulescu, F. (2016). The study of public
                  debt: which are the distinctions between the emerging
                  and advanced economies in the European Union?
                  <span className="text9">Empirica 43 </span>
                  167–196.
                </li>{" "}
              </ul>
            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Card6;
